export const formatName = (name) => {
    return name.replace(/`/g, '').replace(/frame$/i, '').replace(/\b\w/g, char => char.toUpperCase()).trim();
};
